/**
 * EmploymentInformationSection Component
 * Handles employment-related fields: user category, role, department, job title, contract, cost, etc.
 */

import React from "react";
import { LoadingSpinner } from "./common";
import Type from "../../../../../images/icons/type.svg";
import JobTitle from "../../../../../images/icons/job-title.svg";
import TypeContact from "../../../../../images/icons/type-of-contact.svg";
import Company from "../../../../../images/icons/company.svg";
import Payment from "../../../../../images/icons/payment.svg";
import Clock from "../../../../../images/icons/timer.svg";
import Cost from "../../../../../images/icons/cost1.svg";
import userTypeName from "../../../../../constants/userType";
import typeOfContract from "../../../../../constants/typeOfContract";
import overHeadCostTypeConst from "../../../../../constants/overHeadCostType.js";

const EmploymentInformationSection = ({
  isLoading,
  fieldErrors = {},
  clearFieldError,
  userCategory,
  userCategoryName,
  setUserCategory,
  userView,
  userType,
  setUserType,
  userTypeDropdownOpen,
  setUserTypeDropdownOpen,
  userTypeDropdownRef,
  roleId,
  dept,
  setDept,
  deptDropdownOpen,
  setDeptDropdownOpen,
  deptDropdownRef,
  userDept,
  jobTitle,
  setJobTitle,
  overheadCostType,
  typeOverheadCost,
  wxComapny,
  setWxComapny,
  wxComapnyDropdownOpen,
  setWxComapnyDropdownOpen,
  wxComapnyDropdownRef,
  wXCompany,
  capitalizedSubdomain,
  contract,
  setContract,
  contractDropdownOpen,
  setContractDropdownOpen,
  contractDropdownRef,
  typeContract,
  monthlyhours,
  setMonthlyhours,
  currency,
  setCurrency,
  currencyDropdownOpen,
  setCurrencyDropdownOpen,
  currencyDropdownRef,
  currencyList,
  currencySearchTerm,
  handleCurrencySearchInputChange,
  filteredCurrencies,
  cost,
  setCost,
  overheadCost,
  setOverheadCost,
  vat,
  setVat,
  user,
  SUPER_ADMIN,
  ADMIN,
  numberInputOnWheelPreventChange,
}) => {
  return (
    <div className="information-inner">
      <div className="information">
        <div className="information-title">
          Account Information
        </div>
        <div className="information-outer">
          <div className="information-left">
            <div className="inner-detail-outer">
              <div className="inner-detail">
                <span className="icon"><img src={Type} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>User Category *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail-inner detail-radio">
                    {Object.keys(userCategoryName)
                      .filter((key) => key !== 'Vendor' && key !== 'Client')
                      .map((key) => (
                        <div key={userCategoryName[key]} className="radio-option radio-option1">
                          <input
                            type="radio"
                            id={userCategoryName[key]}
                            value={userCategoryName[key] || userView?.user_category || ''}
                            checked={userCategory === userCategoryName[key]}
                            onChange={(e) => setUserCategory(userCategoryName[key])}
                            required
                          />
                          <label htmlFor={userCategoryName[key]}>{key}</label>
                        </div>
                      ))}
                  </div>)}
              </div>
            </div>
            <div className="inner-detail-outer" id="field-userType">
              <div className="inner-detail">
                <span className="icon"><img src={Type} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>Type of Account *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <div className="tooltip-container">
                      <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${userTypeDropdownOpen ? 'open' : ''}${fieldErrors.userType ? ' field-error' : ''}`} ref={userTypeDropdownRef}>
                        <div className="selected-option custom-dropdown-user-new" onClick={(user.userType === SUPER_ADMIN || user.userType === ADMIN) ? () => { setUserTypeDropdownOpen(!userTypeDropdownOpen); clearFieldError?.('userType'); } : null} style={{ cursor: (user.userType === SUPER_ADMIN || user.userType === ADMIN) ? 'pointer' : 'no-drop' }}>
                          {userType ? (roleId.find((role) => role._id === userType)?.user_type === "Project Manager" ? "Project manager (Account manager)" : roleId.find((role) => role._id === userType)?.user_type) : 'Select Role'}
                        </div>
                        {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && userTypeDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <ul className="role-list">
                              {roleId
                                .filter((role) => !(user.userType === ADMIN && role._id === userTypeName.Super_Admin))
                                .map((role) => (
                                  <li
                                    key={role._id}
                                    className={userType === role._id ? 'selected-item' : ''}
                                    onClick={() => {
                                      setUserType(role._id);
                                      setUserTypeDropdownOpen(false);
                                    }}
                                  >
                                    {role.user_type === "Project Manager" ? "Project manager (Account manager)" : role.user_type}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                      {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                        <div className="tooltip-message">
                          You can only view this board
                        </div>
                      )}
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="inner-detail-outer" id="field-dept">
              <div className="inner-detail">
                <span className="icon"><img src={Type} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>Department *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <div className="tooltip-container">
                      <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${deptDropdownOpen ? 'open' : ''}${fieldErrors.dept ? ' field-error' : ''}`} ref={deptDropdownRef}>
                        <div className="selected-option custom-dropdown-user-new" onClick={(user.userType === SUPER_ADMIN || user.userType === ADMIN) ? () => { setDeptDropdownOpen(!deptDropdownOpen); clearFieldError?.('dept'); } : null} style={{ cursor: userType ? 'pointer' : 'no-drop' }}>
                          {dept ? userDept.find((department) => department._id === dept)?.user_department : 'Select Dept'}
                        </div>
                        {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && deptDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <ul className="dept-list">
                              {userDept
                                .slice()
                                .sort((a, b) => a.user_department.toLowerCase().localeCompare(b.user_department.toLowerCase()))
                                .map((department) => (
                                  <li
                                    key={department._id}
                                    className={dept === department._id ? 'selected-item' : ''}
                                    onClick={() => {
                                      setDept(department._id);
                                      setDeptDropdownOpen(false);
                                    }}
                                  >
                                    {department.user_department}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                      {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                        <div className="tooltip-message">
                          You can only view this board
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="inner-detail-outer" id="field-jobTitle">
              <div className="inner-detail">
                <span className="icon"><img src={JobTitle} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>Job Title *</label>
                </div>
              </div>
              {isLoading ? (
                <LoadingSpinner
                  height={18}
                  width={20}
                  radius={9}
                  color="#6479f9"
                />
              ) : (
                <div className="inner-detail">
                  <span className="icon"></span>
                  <div className="inner-detail-inner">
                    <div className="tooltip-container">
                      <input type="text" id="jobtitle" value={jobTitle ?? ''} onChange={(e) => { setJobTitle(e.target.value); clearFieldError?.('jobTitle'); }} required className={fieldErrors.jobTitle ? 'field-error' : ''} />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && (
              <div className="inner-detail-outer" id="field-overheadCostType">
                <div className="inner-detail">
                  <span className="icon"><img src={TypeContact} alt="type" /></span>
                  <div className="inner-detail-inner">
                    <label>Overhead Cost Variable *</label>
                  </div>
                </div>
                <div className="inner-detail">
                  <span className="icon"></span>
                  {isLoading ? (
                    <LoadingSpinner
                      height={18}
                      width={20}
                      radius={9}
                      color="#6479f9"
                    />
                  ) : (
                    <div className="inner-detail-inner">
                      <div className="tooltip-container">
                        <input
                          type="text"
                          placeholder="Overhead Cost Variable"
                          className={`form-input${fieldErrors.overheadCostType ? ' field-error' : ''} read-only-input`}
                          value={overheadCostType ? (typeOverheadCost.find((item) => item._id === overheadCostType)?.overheadCostType ?? 'Select Type of Overhead Cost') : 'Select Type of Overhead Cost'}
                          readOnly
                          required
                        />
                        {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                          <div className="tooltip-message">
                            You can only view this board
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="inner-detail-outer" id="field-wxComapny">
              <div className="inner-detail">
                <span className="icon"><img src={Company} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>{`${capitalizedSubdomain} Company *`}</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <div className="tooltip-container">
                      <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${wxComapnyDropdownOpen ? 'open' : ''}${fieldErrors.wxComapny ? ' field-error' : ''}`} ref={wxComapnyDropdownRef}>
                        <div className="selected-option custom-dropdown-user-new" onClick={(user.userType === SUPER_ADMIN || user.userType === ADMIN) ? () => { setWxComapnyDropdownOpen(!wxComapnyDropdownOpen); clearFieldError?.('wxComapny'); } : null} style={{ cursor: (user.userType === SUPER_ADMIN || user.userType === ADMIN) ? 'pointer' : 'no-drop' }}>
                          {wxComapny ? wXCompany.find((company) => company._id === wxComapny)?.wx_company : `Select ${capitalizedSubdomain} Comp`}
                        </div>
                        {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && wxComapnyDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <ul className="company-list">
                              {wXCompany.map((company) => (
                                <li
                                  key={company._id}
                                  className={wxComapny === company._id ? 'selected-item' : ''}
                                  onClick={() => {
                                    setWxComapny(company._id);
                                    setWxComapnyDropdownOpen(false);
                                  }}
                                >
                                  {company.wx_company}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                      {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                        <div className="tooltip-message">
                          You can only view this board
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="information-right">
            <div className="inner-detail-outer" id="field-contract">
              <div className="inner-detail">
                <span className="icon"><img src={TypeContact} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>Type of contract *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <div className="tooltip-container">
                      <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${contractDropdownOpen ? 'open' : ''}${fieldErrors.contract ? ' field-error' : ''}`} ref={contractDropdownRef}>
                        <div className="selected-option custom-dropdown-user-new" onClick={(user.userType === SUPER_ADMIN || user.userType === ADMIN) ? () => { setContractDropdownOpen(!contractDropdownOpen); clearFieldError?.('contract'); } : null} style={{ cursor: userType ? 'pointer' : 'no-drop' }}>
                          {contract ? typeContract.find((item) => item._id === contract)?.typeOfContract : 'Select Type of Contract'}
                        </div>
                        {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && contractDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <ul className="contract-list">
                              {typeContract.map((item) => (
                                <li
                                  key={item._id}
                                  className={contract === item._id ? 'selected-item' : ''}
                                  onClick={userType ? () => {
                                    setContract(item._id);
                                    setContractDropdownOpen(false);
                                  } : null}
                                >
                                  {item.typeOfContract}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                      {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                        <div className="tooltip-message">
                          You can only view this board
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && (
              <div className="inner-detail-outer" id="field-monthlyhours">
                <div className="inner-detail">
                  <span className="icon"><img src={Clock} alt="type" /></span>
                  <div className="inner-detail-inner">
                    <label>Total Hours * </label>
                  </div>
                </div>
                <div className="inner-detail">
                  <span className="icon"></span>
                  {isLoading ? (
                    <LoadingSpinner
                      height={18}
                      width={20}
                      radius={9}
                      color="#6479f9"
                    />
                  ) : (
                    <div className="inner-detail-inner">
                      <div className="tooltip-container">
                        <input type="number" className={[
                            (user.userType !== SUPER_ADMIN && user.userType !== ADMIN) ? 'read-only-input' : '',
                            fieldErrors.monthlyhours ? 'field-error' : '',
                          ].filter(Boolean).join(' ') || undefined} id="monthlyhours" value={monthlyhours ?? ''} onChange={(e) => { setMonthlyhours(e.target.value); clearFieldError?.('monthlyhours'); }} readOnly={(user.userType !== SUPER_ADMIN && user.userType !== ADMIN)} required onWheel={numberInputOnWheelPreventChange} />
                        {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                          <div className="tooltip-message">
                            You can only view this board
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="inner-detail-outer" id="field-currency">
              <div className="inner-detail">
                <span className="icon"><img src={Payment} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>Payment Currency *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <div className="tooltip-container">
                      <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${currencyDropdownOpen ? 'open' : ''}${fieldErrors.currency ? ' field-error' : ''}`} ref={currencyDropdownRef}>
                        <div className="selected-option custom-dropdown-user-new" onClick={(user.userType === SUPER_ADMIN || user.userType === ADMIN) ? () => { setCurrencyDropdownOpen(!currencyDropdownOpen); clearFieldError?.('currency'); } : null} style={{ cursor: (user.userType === SUPER_ADMIN || user.userType === ADMIN) ? 'pointer' : 'no-drop' }}>
                          {currency ? currencyList.find((c) => c.currencyCode === currency)?.currencyCode : 'Select Currency'}
                        </div>
                        {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && currencyDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <input
                              type="text"
                              className="search-bar"
                              placeholder="Search..."
                              value={currencySearchTerm ?? ''}
                              onChange={handleCurrencySearchInputChange}
                            />
                            <ul className="currency-list">
                              {filteredCurrencies.length > 0 &&
                                filteredCurrencies.map((c) => (
                                  <li
                                    key={c.currencyCode}
                                    className={currency === c.currencyCode ? 'selected-item' : ''}
                                    onClick={() => {
                                      setCurrency(c.currencyCode);
                                      setCurrencyDropdownOpen(false);
                                    }}
                                  >
                                    {`${c.currencyCode} (${c.currencyName})`}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                      {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                        <div className="tooltip-message">
                          You can only view this board
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && (
              <div className="inner-detail-outer" id="field-cost">
                <div className="inner-detail">
                  <span className="icon"><img src={Cost} alt="type" /></span>
                  <div className="inner-detail-inner">
                    {contract === typeOfContract.Hourly_Rate ? (
                      <label>
                        Compensation per Hour {currency && `(${currency})`} *
                      </label>
                    ) : (
                      <label>
                        Monthly Compensation {currency && `(${currency})`} *
                      </label>
                    )}
                  </div>
                </div>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail">
                    <span className="icon"></span>
                    <div className="inner-detail-inner">
                      <div className="tooltip-container">
                        <input type="number" className={[
                            (user.userType !== SUPER_ADMIN && user.userType !== ADMIN) ? 'read-only-input' : '',
                            fieldErrors.cost ? 'field-error' : '',
                          ].filter(Boolean).join(' ') || undefined} id="cost" value={cost ?? ''} onChange={(e) => { setCost(e.target.value); clearFieldError?.('cost'); }} readOnly={(user.userType !== SUPER_ADMIN && user.userType !== ADMIN)} required onWheel={numberInputOnWheelPreventChange} />
                        {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                          <div className="tooltip-message">
                            You can only view this board
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>)}

            {(user.userType === SUPER_ADMIN || user.userType === ADMIN) && (
              <div className="inner-detail-outer" id="field-overheadCost">
                <div className="inner-detail">
                  <span className="icon"><img src={Cost} alt="type" /></span>
                  <div className="inner-detail-inner">
                    {overheadCostType === overHeadCostTypeConst.Cost_per_Hour ? (
                      <label>
                        Overhead Cost per Hour {currency && `(${currency})`} *
                      </label>
                    ) : (
                      <label>
                        Monthly Overhead Cost {currency && `(${currency})`} *
                      </label>
                    )}
                  </div>
                </div>
                {isLoading ? (
                  <LoadingSpinner
                    height={18}
                    width={20}
                    radius={9}
                    color="#6479f9"
                  />
                ) : (
                  <div className="inner-detail">
                    <span className="icon"></span>
                    <div className="inner-detail-inner">
                      <div className="tooltip-container">
                        <input type="number" className={[
                            (user.userType !== SUPER_ADMIN && user.userType !== ADMIN) ? 'read-only-input' : '',
                            fieldErrors.overheadCost ? 'field-error' : '',
                          ].filter(Boolean).join(' ') || undefined} id="overheadCost" value={overheadCost ?? ''} onChange={(e) => { setOverheadCost(e.target.value); clearFieldError?.('overheadCost'); }} readOnly={(user.userType !== SUPER_ADMIN && user.userType !== ADMIN)} required onWheel={numberInputOnWheelPreventChange} />
                        {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                          <div className="tooltip-message">
                            You can only view this board
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>)}
            <div className="inner-detail-outer" id="field-vat">
              <div className="inner-detail">
                <span className="icon"><img src={TypeContact} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label>VAT (%) *</label>
                </div>
              </div>
              {isLoading ? (
                <LoadingSpinner
                  height={18}
                  width={20}
                  radius={9}
                  color="#6479f9"
                />
              ) : (
                <div className="inner-detail">
                  <span className="icon"></span>
                  <div className="inner-detail-inner">
                    <div className="tooltip-container">
                      <input type="number" className={[
                          (user.userType !== SUPER_ADMIN && user.userType !== ADMIN) ? 'read-only-input' : '',
                          fieldErrors.vat ? 'field-error' : '',
                        ].filter(Boolean).join(' ') || undefined} id="vat" value={vat ?? ''} onChange={(e) => { setVat(e.target.value); clearFieldError?.('vat'); }} readOnly={(user.userType !== SUPER_ADMIN && user.userType !== ADMIN)} required onWheel={numberInputOnWheelPreventChange} />
                      {(user.userType !== SUPER_ADMIN && user.userType !== ADMIN) && (
                        <div className="tooltip-message">
                          You can only view this board
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmploymentInformationSection;
